import React, { Component } from "react";

import {
  Row,
  Col,
  Container,
  DropdownToggle,
  Button,
  InputGroup,
  Input
} from "reactstrap";
import uuid from "uuid";
import { withRouter } from "react-router-dom";
import { isMobileOnly } from 'react-device-detect';

// Custom Components
import UserDropdownModal from "./UserDropdownModal";
// import SettingsModal from "./SettingsModal";
import { LinkListButton } from './LinkListButton';

// Styles
import "./Header.less";

// Strings
import { getMessage } from "CONFIG/i18n";

// Utilities
import { getUserNameAcronym,  getUserNameForSelectedLanguage } from "UTILS/Utility";
import { APP_CONFIG, modulesAvailableConstant } from "UTILS/Constants";

// Images
import logo from "ASSETS/Images/img_header_logo.webp";
import ic_add_member from "ASSETS/Images/ic_add_organization.svg";
import ic_search from "ASSETS/Images/ic_search.svg";
import ic_cancel from "ASSETS/Images/ic_cancel_start_session.svg";
import ic_settings from "ASSETS/Images/ic_settings.svg";
import expand_button from "ASSETS/Images/expand-button16.webp";
import { toast } from 'react-toastify';
import { USER_ROLES } from "../../../Utils/Constants";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showUserInfoModal: false,
      searchString: "",
      searchTimeout: null
    };
  }

  getUserLogo = () => {
    return (
      <DropdownToggle className="dropdownToggleButton mr-2 pr-0" onClick={this.toggle}>
        {" "}
        <span className="card-text displayFlex alignItemsCenter justifyContentFlexCenter noPadding" key={uuid.v4()}>
          {getUserNameAcronym(getUserNameForSelectedLanguage(this.props.language, this.props.username))}
        </span>
      </DropdownToggle>
    );
  };

  toggle = () => {
    this.setState({
      showUserInfoModal: !this.state.showUserInfoModal
    });
  };

  closePopup = value => {
    this.setState({ showUserInfoModal: value });
  };
  handleSearch = e => {
    let searchData = e.target.value
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }
    if(this.state.searchString !== searchData)
      this.setState({
        searchString: searchData,
        searchTimeout: setTimeout(() => {
          this.props.handleSearchString(searchData);
        }, 1000)
      });

  };
  onCancelButton = () => {
    this.setState({ searchString: "" });
    //toast.removeByType("error");
    toast.dismiss()
    this.props.onCancelButton();
  }

  showModalOrPage = () => {
    if(this.props.role === USER_ROLES.SUPER_ADMIN) {
      this.props.gotoAddOrganization();
    } else {
      this.props.showAddUserModal();
    }
  }

  render = () => {
    let singleTitleHeader = (!isMobileOnly && 
    (this.props.title === getMessage("ADD_ORGANIZATION") || this.props.title === getMessage("EDIT_ORGANIZATION") || this.props.title === getMessage("SETTINGS")))
    return (
      <div className="superAdmin">
        <section className="header py-1">
          <Container className="pl-lg-0">
            <Row>
              <Col lg="4" md={singleTitleHeader ? "4" : "2"} xs="12" className="noPadding perfectCenter">
                <div className="logoHeader displayFlex">
                  <img className="Orglogo" src={this.props.role === USER_ROLES.SUPER_ADMIN ? logo : this.props.logoUrl} />
                </div>
                <Col className="title " >
                  <label 
                    className={"nameEllipsis " + (!singleTitleHeader ? "setWidthForHeader" : "") }
                    title={this.props.title} >
                    {this.props.title}
                  </label>
                </Col>
              </Col>
              {!this.props.isSuperAdmin && this.props.showQR && this.props.isDashboard ? (
                <Col lg="2" className="displayFlex alignItemsCenter noPadding">
                  <Button
                    className="customBtn headerAddButton blinkBtn "
                    onClick={this.props.showQRPopUp}
                  >
                    {getMessage("GET_QR")}
                  </Button>
                </Col>
              ) : null}
              {this.props.isSuperAdmin && this.props.isDashboard && 
              (<Col className="searchBox noPadding perfectCenter">
                <InputGroup className="alignItemsCenter">
                  <Input
                    className="form-control py-2 "
                    type="text"
                    id="example-search-input"
                    onChange={this.handleSearch}
                    value={this.state.searchString}
                  />
                  {this.state.searchString && (
                    <img src={ic_cancel} className="cursorPointer" onClick={this.onCancelButton} />
                  )}
                  <img src={ic_search} disabled />
                </InputGroup>
              </Col>)
              }

              <Col className="displayFlex justifyContentFlexEnd alignItemsCenter noPadding">
                {!this.props.isSuperAdmin && this.props.modules.includes(modulesAvailableConstant.SUPPORT_CENTER) && this.props.isDashboard ? (
                  <LinkListButton />
                ) : null}
                {this.props.isDashboard && <span className="borderRight">
                  <Button
                    className= {this.props.isSuperAdmin 
                      ? "customBtn headerAddButton whiteOnClick ripple"
                      : "customBtn headerAddButton whiteOnClick ripple addUserButton"
                    }
                    onClick={this.showModalOrPage}
                  >
                    <img src={ic_add_member} className="button "/>
                    {this.props.headerButtonText}                                     
                  </Button>
                    
                  { this.props.isAdmin && 
                    <Button 
                      id="target" 
                      className="mergedCustomBtn headerAddButton whiteOnClick ripple"
                      onClick = {this.props.showAddUserDropdown}
                    > 
                      <img src={expand_button} className="button"/>
                    </Button>
                  }
                </span>  
                }
                {
                  this.props.showSettingsOption ?
                    <div className="settingsImg cursorPointer">
                      <img
                        src={ic_settings}
                        onClick={this.props.gotoAdminSettings}
                      />
                    </div> : null
                }
                <UserDropdownModal
                  show={this.state.showUserInfoModal && this.props.isDashboard}
                  userIcon={this.props.isDashboard?this.getUserLogo():null}
                  toggle={this.toggle}
                  handleLogoutClick={this.props.handleLogoutClick}
                  showAboutOrgModal={this.props.showAboutOrgModal}
                  isSuperAdmin={this.props.isSuperAdmin}
                  userProfileData={this.props.userProfileData}
                  handleUpdateProfileClick={this.props.handleUpdateProfileClick}
                  toggleChangePasswordModal={this.props.toggleChangePasswordModal}
                  showChangePasswordModal={this.props.showChangePasswordModal}
                  role={this.props.role}
                  isSSOEnabled={this.props.isSSOEnabled}
                  isSSOLogin={this.props.isSSOLogin}
                  language={this.props.language}
                  lastLoginDate={this.props.lastLoginDate}
                />
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    );
  };
}

export default withRouter(Header);
